"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnConfiguration = void 0;
var tslib_1 = require("tslib");
var responsive_1 = require("../_chartCreators/responsive");
var commonConfiguration_1 = require("../_chartCreators/commonConfiguration");
var common_1 = require("../_util/common");
function getColumnConfiguration(config, _definition, theme) {
    var _a, _b, _c;
    var columnConfiguration = {
        chart: {
            type: "column",
            spacingTop: 20,
        },
        plotOptions: {
            column: {
                dataLabels: {
                    enabled: true,
                    padding: 2,
                },
                maxPointWidth: commonConfiguration_1.MAX_POINT_WIDTH,
            },
            series: {
                states: {
                    hover: {
                        enabled: false,
                    },
                },
            },
        },
        yAxis: [
            {
                stackLabels: tslib_1.__assign({ enabled: true, allowOverlap: false }, (((_a = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _a === void 0 ? void 0 : _a.complementary) && {
                    style: {
                        color: (_c = (_b = theme === null || theme === void 0 ? void 0 : theme.palette) === null || _b === void 0 ? void 0 : _b.complementary) === null || _c === void 0 ? void 0 : _c.c9,
                        textOutline: "none",
                    },
                })),
            },
        ],
    };
    if ((config === null || config === void 0 ? void 0 : config.enableCompactSize) && !(config === null || config === void 0 ? void 0 : config.zoomInsight)) {
        var _d = common_1.getAxesCounts(config), xAxesCount = _d[0], yAxesCount = _d[1];
        return tslib_1.__assign(tslib_1.__assign({}, columnConfiguration), { responsive: responsive_1.getCommonResponsiveConfig(false, xAxesCount, yAxesCount) });
    }
    return columnConfiguration;
}
exports.getColumnConfiguration = getColumnConfiguration;
//# sourceMappingURL=columnConfiguration.js.map